import * as React from 'react';
import { AnimatedBackground } from './animated-background';
import type { AnimatedBackgroundProps } from './animated-background';

export interface MarketingHeroProps {
  children: React.ReactNode;
  variant?: 'hero' | 'cta';
  intensity?: AnimatedBackgroundProps['intensity'];
  className?: string;
}

const MarketingHero: React.FC<MarketingHeroProps> = ({
  children,
  variant = 'hero',
  intensity = 'normal',
  className = '',
}) => {
  return (
    <section className={`relative overflow-hidden ${className}`}>
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900" />
      <AnimatedBackground variant={variant} intensity={intensity} />
      <div className="relative">
        {children}
      </div>
    </section>
  );
};

export { MarketingHero };
